import React, { CSSProperties } from "react"
import styled from "styled-components"
import { colors } from "styles/colors"

const DefaultTextStyles = styled.h1`
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: anywhere;
  margin: 0;
  padding: 0;

  &.center {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
`

export const Heading: React.FC<{
  color?: string
  size?: number
  textAlign?: "justify" | "left" | "center"
  className?: string
  noWrap?: boolean
  fontWeight?: number
  style?: CSSProperties
  onClick?: () => void
}> = ({
  children,
  color,
  size,
  textAlign,
  className,
  noWrap,
  fontWeight,
  style,
  ...rest
}) => (
  <DefaultTextStyles
    {...rest}
    className={className ? className : textAlign === "center" ? "center" : ""}
    style={{
      color: color ? color : colors.black,
      fontSize: size ? `${size}px` : undefined,
      textAlign,
      whiteSpace: noWrap ? "nowrap" : "normal",
      fontWeight,
      ...style,
    }}
  >
    {children}
  </DefaultTextStyles>
)
